export default function Menu(props) {
  const s = props?.size ?? 24;
  const c = props?.color ?? '#292D32';
  const stroke = props?.strokeWidth ?? 1.5;

  return (
    <svg width={s} height={s} viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.34998 9.6499V11.3499C4.34998 15.5699 7.77998 18.9999 12 18.9999M12 18.9999C16.22 18.9999 19.65 15.5699 19.65 11.3499V9.6499M12 18.9999L12 22M10.61 6.43012C11.51 6.10012 12.49 6.10012 13.39 6.43012M11.2 8.55007C11.73 8.41007 12.28 8.41007 12.81 8.55007M12 15.5C14.21 15.5 16 13.71 16 11.5V6C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6V11.5C8 13.71 9.79 15.5 12 15.5Z"
        stroke={c}
        strokeWidth={stroke}
      />
    </svg>
  );
}
